/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserTeam } from './userTeam';
import { RoleEnum } from './roleEnum';
import { UserPermissions } from './userPermissions';
import { GenderEnum } from './genderEnum';


import {ValidatorFn, Validators} from "@angular/forms";

export interface User { 
    readonly id: number;
    name: string;
    email: string;
    role: RoleEnum | null;
    gender: GenderEnum | null;
    readonly isTherapist: boolean;
    readonly isPatientops: boolean;
    /**
     * Legt fest, ob sich der Benutzer an der Administrationsseite anmelden kann.
     */
    isStaff?: boolean;
    /**
     * Legt fest, dass der Benutzer alle Berechtigungen hat, ohne diese einzeln zuweisen zu müssen.
     */
    readonly isSuperuser: boolean;
    readonly adminUrl: string | null;
    readonly therapistId: number | null;
    readonly associatedTherapistIds: Array<number>;
    readonly userPermissions: UserPermissions;
    readonly isHijacked: boolean;
    readonly teams: Array<UserTeam>;
}
export namespace User {
}

export const User_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const User_name_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.maxLength(255),];

export const User_email_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.maxLength(254), Validators.email,];

export const User_role_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const User_gender_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const User_isTherapist_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const User_isPatientops_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const User_isStaff_Validators: ValidatorFn[] =
    [ ];

export const User_isSuperuser_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const User_adminUrl_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const User_therapistId_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const User_associatedTherapistIds_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const User_userPermissions_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const User_isHijacked_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const User_teams_Validators: ValidatorFn[] =
    [  Validators.required, ];


